import BaseModelAPI from '../BaseModelAPI';

export default class SubprocessList extends BaseModelAPI {

	static entity = 'subprocesslist'
	static entityName = 'subprocess';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
